// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8efcd0c1","455":"b5c5481d","977":"06bad700"}[chunkId] + ".chunk.js";
};